var _ellipse, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTumerGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.99992,
    cy: 11.6667,
    rx: 6.66667,
    ry: 6.66667,
    stroke: "#A2A1AB",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.6666L10 9.16663",
    stroke: "#A2A1AB",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 6.25L15.8333 5",
    stroke: "#A2A1AB",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39021 1.97545C8.48516 1.88685 8.69441 1.80857 8.98548 1.75273C9.27655 1.69689 9.63319 1.66663 10.0001 1.66663C10.367 1.66663 10.7236 1.69689 11.0147 1.75273C11.3058 1.80857 11.515 1.88685 11.61 1.97545",
    stroke: "#A2A1AB",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTumerGray);
export default __webpack_public_path__ + "static/media/tumer-gray.be04c1985709dbf5bf97a9d50662b0cf.svg";
export { ForwardRef as ReactComponent };